import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React from "react";
import { gql, useMutation } from "@apollo/client";
import { Card, CardContent, CardActions, Button, makeStyles, Grid, FormField, FormSnackBar, Avatar, FormControlLabel, Switch, InputFileUpload, Loader, } from "../../mui";
import { styled } from "@mui/material/styles";
import { ContentTypography, getContent } from "../../common/content";
import ColorModeContext from "../../../routes/ColorModeContext";
import { AppMode, FormFieldType, currency, PlatformLanguage } from "../../../utils/enums";
import defaults from "../../../utils/defaults";
export const EDIT_USER = gql `
  mutation EditUser($id: ID!, $data: userInput!) {
    editUser(id: $id, data: $data) {
      id
    }
  }
`;
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    "& .MuiSwitch-switchBase": {
        margin: 1,
        padding: 0,
        transform: "translateX(6px)",
        "&.Mui-checked": {
            color: "#fff",
            transform: "translateX(22px)",
            "& .MuiSwitch-thumb:before": {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent("#fff")}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
            },
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
            },
        },
    },
    "& .MuiSwitch-thumb": {
        backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
        width: 32,
        height: 32,
        "&::before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            left: 0,
            top: 0,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent("#fff")}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
        },
    },
    "& .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
        borderRadius: 20 / 2,
    },
}));
const useStyles = makeStyles((theme) => ({
    card: {
        overflow: "hidden",
        overflowX: "hidden",
        padding: 20,
        borderRadius: 9,
    },
    tabLabel: {
        fontWeight: "bold",
    },
    untransformBttn: {
        textTransform: "none",
    },
}));
const Personal = ({ data }) => {
    const classes = useStyles();
    const colorMode = React.useContext(ColorModeContext);
    const [user, setUser] = React.useState(defaults.users);
    const [actionsVisible, setActionsVisible] = React.useState(false);
    const [snackBar, setSnackBar] = React.useState({
        open: false,
        message: "",
        type: "",
    });
    const [editUser, { loading: editUserLoading }] = useMutation(EDIT_USER);
    React.useEffect(() => {
        setUser(data?.user || defaults.users);
    }, [data]);
    const handleUserChange = (event) => {
        setActionsVisible(true);
        if (event?.target?.name === "language") {
            setUser({
                ...user,
                platformSettings: {
                    ...user?.platformSettings,
                    language: event?.target?.value,
                },
            });
            localStorage.setItem("language", event?.target?.value);
        }
        else if (event?.target?.name === "currency") {
            setUser({
                ...user,
                platformSettings: {
                    ...user?.platformSettings,
                    currency: event?.target?.value,
                },
            });
            localStorage.setItem("currency", event?.target?.value);
        }
        else if (event?.target?.name === "uploadAvatar") {
            setUser({
                ...user,
                uploadAvatar: event.target.files[0],
            });
        }
        else {
            setUser({
                ...user,
                [event.target.name]: event.target.value,
            });
        }
    };
    const onPersonalSave = () => {
        const id = user.id;
        const data = {
            firstName: user?.firstName || "",
            lastName: user?.lastName || "",
            dateOfBirth: user?.dateOfBirth || null,
            phoneNumber: user?.phoneNumber || "",
            uploadAvatar: user?.uploadAvatar || null,
            platformSettings: {
                language: user?.platformSettings?.language,
                currency: user?.platformSettings?.currency,
                mode: user?.platformSettings?.mode,
            },
        };
        editUser({
            variables: {
                id,
                data,
            },
            onCompleted: () => setSnackBar({
                open: true,
                message: `Updated user successfully!`,
                type: "success",
            }),
            onError: () => setSnackBar({
                open: true,
                message: `${getContent("errorMessage")}`,
                type: "error",
            }),
        });
        setActionsVisible(false);
    };
    if (editUserLoading)
        return _jsx(Loader, { size: 60 });
    return (_jsxs(_Fragment, { children: [_jsx(FormSnackBar, { snackBar: snackBar, setSnackBar: setSnackBar }), _jsxs(Card, { className: classes.card, children: [_jsxs(CardContent, { children: [_jsx(Grid, { container: true, justifyContent: "flex-end", alignItems: "flex-end", children: _jsx(Grid, { item: true, children: _jsx(FormControlLabel, { control: _jsx(MaterialUISwitch, { sx: { m: 1 }, checked: user?.platformSettings?.mode === AppMode.dark, onClick: () => {
                                                editUser({
                                                    variables: {
                                                        id: user?.id,
                                                        data: {
                                                            platformSettings: {
                                                                language: user?.platformSettings?.language,
                                                                currency: user?.platformSettings?.currency,
                                                                mode: user?.platformSettings?.mode === AppMode.light ? AppMode.dark : AppMode.light,
                                                            },
                                                        },
                                                    },
                                                    onCompleted: () => setSnackBar({
                                                        open: true,
                                                        message: `Updated personal info successfully!`,
                                                        type: "success",
                                                    }),
                                                    onError: () => setSnackBar({
                                                        open: true,
                                                        message: `${getContent("errorMessage")}`,
                                                        type: "error",
                                                    }),
                                                });
                                                colorMode.toggleColorMode();
                                            } }), label: "" }) }) }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Avatar, { alt: "avatar", src: user?.avatar?.url, sx: { width: 148, height: 148 } }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(InputFileUpload, { name: "uploadAvatar", onChange: handleUserChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: true, name: "email", fieldType: FormFieldType.TextField, value: user?.email, label: getContent("emailLabel"), onChange: handleUserChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { name: "firstName", fieldType: FormFieldType.TextField, value: user?.firstName, label: getContent("firstNameLabel"), onChange: handleUserChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { name: "lastName", fieldType: FormFieldType.TextField, value: user?.lastName, label: getContent("lastNameLabel"), onChange: handleUserChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { name: "dateOfBirth", label: getContent("dobLabel"), fieldType: FormFieldType.Date, value: user?.dateOfBirth, onChange: handleUserChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { name: "phoneNumber", fieldType: FormFieldType.PhoneNumber, value: user?.phoneNumber, label: getContent("phoneNumberLabel"), onChange: handleUserChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { name: "language", fieldType: FormFieldType.SingleSelect, enumValues: Object.keys(PlatformLanguage), value: user?.platformSettings?.language, label: getContent("platformLanguageLabel"), onChange: handleUserChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { name: "currency", fieldType: FormFieldType.SingleSelect, enumValues: Object.keys(currency), value: user?.platformSettings?.currency, label: getContent("preferredCurrencyLabel"), onChange: handleUserChange }) })] })] }), _jsx(CardActions, { children: actionsVisible ? (_jsxs(Grid, { item: true, xs: 12, container: true, spacing: 2, justifyContent: "flex-end", alignItems: "flex-end", children: [_jsx(Grid, { item: true, children: _jsx(Button, { className: classes.untransformBttn, onClick: onPersonalSave, children: _jsx(ContentTypography, { variant: "button", color: "primary", fontWeight: "bold", sx: { textTransform: "none" }, field: "saveChangesLabel" }) }) }), _jsx(Grid, { item: true, children: _jsx(Button, { className: classes.untransformBttn, onClick: () => {
                                            setUser(data?.user);
                                            setActionsVisible(false);
                                        }, children: _jsx(ContentTypography, { variant: "button", color: "secondary", fontWeight: "bold", sx: { textTransform: "none" }, field: "cancelLabel" }) }) })] })) : null })] })] }));
};
export default Personal;
